import { render } from "./IconHelpcircle.vue?vue&type=template&id=0e85e61a"
import script from "./IconHelpcircle.vue?vue&type=script&lang=js"
export * from "./IconHelpcircle.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__